import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { StandardListComponent } from './standard-list/standard-list.component';
import { StandardDetailsComponent } from './standard-details/standard-details.component';
import { AddResultComponent } from './add-result/add-result.component';

const routes: Routes = [
  { path: '', component: StandardListComponent },
  { path: 'standard-list', component: StandardListComponent },
  { path: 'standard-details', component: StandardDetailsComponent },
  { path: 'add-result', component: AddResultComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class StudentResultRoutingModule { }
